import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useEventCallback, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { InputWrapper } from '../../../internal/components/InputWrapper';
import { useControlled } from '../../../internal/hooks';
import { Slider } from '../../../slider';
import { INPUT_WRAPPER_PICK_PROPS, SLIDER_PICK_PROPS } from '../../internal';
import styles from './styles.module.css';
import { IMaskInput } from '../../../internal/components/IMaskInput';
import { omit, pick } from 'ramda';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var pickSliderProps = pick(SLIDER_PICK_PROPS);
var pickInputWrapperProps = pick(INPUT_WRAPPER_PICK_PROPS);
var pickInputProps = omit([].concat(_toConsumableArray(SLIDER_PICK_PROPS), _toConsumableArray(INPUT_WRAPPER_PICK_PROPS)));
var IMASK_OPTIONS = {
  mask: Number,
  thousandsSeparator: "\u2009",
  signed: true
};
export function InputSlider(props) {
  var onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    min = props.min,
    defaultValue = props.defaultValue;
  var _useControlled = useControlled({
      controlled: props.value,
      default: defaultValue !== undefined ? defaultValue : min
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];
  var _React$useState = React.useState(String(value)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    focused = _React$useState4[0],
    setFocused = _React$useState4[1];
  var handleInputAccept = useEventCallback(function (eventValue) {
    setInputValue(eventValue);
    if (!eventValue) {
      return;
    }
    var nextValue = Number(eventValue);
    setValue(nextValue);
    if (onChange && nextValue !== value) {
      onChange(nextValue);
    }
  });
  var handleSliderChange = useEventCallback(function (nextValue) {
    setValue(nextValue);
    if (onChange) {
      onChange(nextValue);
    }
  });
  var handleFocus = useEventCallback(function (e) {
    setFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  });
  var handleBlur = useEventCallback(function (e) {
    setFocused(false);
    if (onBlur) {
      onBlur(e);
    }
    var finalValue = toSliderValue(inputValue, min);
    if (onChange && value !== finalValue) {
      onChange(finalValue);
    }
  });
  useIsomorphicLayoutEffect(function () {
    setInputValue(String(value));
  }, [value]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['input-slider'],
    children: [/*#__PURE__*/_jsx(InputWrapper, _objectSpread(_objectSpread({}, pickInputWrapperProps(props)), {}, {
      focused: focused,
      size: "M",
      children: /*#__PURE__*/_jsx(IMaskInput, _objectSpread(_objectSpread({}, pickInputProps(props)), {}, {
        ref: props.inputRef,
        className: styles['input'],
        onFocus: handleFocus,
        onBlur: handleBlur,
        value: inputValue,
        options: IMASK_OPTIONS,
        onAccept: handleInputAccept,
        disabled: props.disabled,
        preventActiveUpdate: true
      }))
    })), /*#__PURE__*/_jsx("div", {
      className: styles['slider'],
      children: /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, pickSliderProps(props)), {}, {
        __theme: "input",
        value: toSliderValue(inputValue, min),
        onChange: handleSliderChange,
        step: step,
        valueLabelDisplay: "off",
        tabIndex: -1
      }))
    })]
  });
}
function toSliderValue(inputValue, min) {
  return inputValue === '' ? min : Number(inputValue);
}